import React from 'react';
import Select from 'react-select';

const Typeahead = (props) => {
  return (
    <Select
      options={props.options}
      onChange={(selectedOption) => props.onChange(selectedOption)}
      // onChange={props.onChange} 
      placeholder={props.placeholder || 'Select...'}
      value={props.value}
      isDisabled={props.disabled}
      isClearable={props.isClearable !== undefined ? props.isClearable : true}
      className="col-sm-12"
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          height: 45,
        }),
      }}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: 'rgba(83, 70, 134, 0.474)',
          primary: '#534686',
          primary50: 'rgba(83, 70, 134, 0.3)'
        },
      })}
    />
  );
}

export default Typeahead;